import Vue from "vue";
import Router from "vue-router";

import Home from './components/pages/Home.vue'
import Rubric from './components/pages/Rubric.vue'
import Article from './components/pages/Article.vue'
import LocationCenter from './components/pages/Location.vue'
import Faq from './components/pages/Faq.vue'
import About from './components/pages/About.vue'
import Contact from './components/pages/Contact.vue'
import AskQuestion from './components/pages/AskQuestion.vue'
import News from './components/pages/News.vue'
import SingleNews from './components/pages/SingleNews.vue'
import Search from './components/pages/Search.vue'

import NotFound from './components/pages/404.vue'


Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            meta: { title: "Главная", titleKz: "Басты бет" },
            component: Home
        },
        {
            path: "/rubric",
            name: "rubric",
            meta: { title: "Рубрики", titleKz: "Айдарлар" },
            component: Rubric,
            props: true
        },
        {
            path: "/article/:id",
            name: "article",
            meta: { title: "Артикль", titleKz: "Мақала" },
            component: Article,
            props: true
        },
        {
            path: "/location",
            name: "location",
            meta: { title: "МЦЗ", titleKz: "Жастар Денсаулық Орталықтары" },
            component: LocationCenter
        },
        {
            path: "/faq",
            name: "faq",
            meta: { title: "Вопросы и Ответы", titleKz: "Сұрақ-жауап" },
            component: Faq
        },
        {
            path: "/about",
            name: "about",
            meta: { title: "О проекте", titleKz: "Жоба туралы" },
            component: About,
            props: true
        },
        {
            path: "/contact",
            name: "contact",
            meta: { title: "Контакты", titleKz: "Байланыстар" },
            component: Contact
        },
        {
            path: "/ask-question",
            name: "ask-question",
            meta: { title: "Задать анонимный вопрос", titleKz: "Анонимді сұрақ қою" },
            component: AskQuestion
        },
        {
            path: "/news",
            name: "news",
            meta: { title: "Новости", titleKz: "Жаңалықтар" },
            component: News
        },
        {
            path: "/news/:title",
            name: "single-news",
            meta: { title: "Новости", titleKz: "Жаңалықтар" },
            component: SingleNews
        },
        {
            path: "/search",
            name: "search",
            meta: { title: "Поиск", titleKz: "Іздеу" },
            component: Search
        },
        { 
            path: "*", 
            meta: { title: "Не найдено", titleKz: "Табылмады" },
            component: NotFound 
          }
    ]
})